import styled from '@emotion/styled';
import { css_xlarge, css_text } from '~/emotion/theme';
import { useEffect, useState } from 'react';
import useIsGrid from '~/hooks/useIsGrid';

const Wrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
`;

const Ratio = styled.div<{ render: boolean; grid: boolean }>`
	position: relative;
	width: 100%;
	aspect-ratio: 16 / 9;
	background: ${css_text()};

	@media (${css_xlarge}) {
		width: ${({ grid }) => (grid ? '100%' : '90%')};
	}

	> * {
		visibility: ${({ render }) => (render ? 'visible' : 'hidden')};
	}
`;

export default function MicrositeRatio({ id, children }: { id: string; children?: React.ReactNode }) {
	const [render, setRender] = useState(true);
	const isGrid = useIsGrid();

	useEffect(() => {
		let timeout: ReturnType<typeof setTimeout>;

		const resizeStart = () => {
			if (render) {
				setRender(false);
			}

			if (timeout) {
				clearTimeout(timeout);
			}

			timeout = setTimeout(() => {
				setRender(true);
			}, 500);
		};

		window.addEventListener('resize', resizeStart);

		return () => {
			window.removeEventListener('resize', resizeStart);
		};
	}, [render]);

	return (
		<Wrapper id={id}>
			<Ratio render={render} grid={isGrid}>
				{children}
			</Ratio>
		</Wrapper>
	);
}
